*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  cursor: pointer;
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
}

.wui-radio {
  cursor: pointer;
  user-select: none;

  display: inline-flex;
  gap: 10px;
  align-items: center;

  font-size: var(--wui-font-size, 14px);
  line-height: 1;
  color: var(--wui-color-text, #1b1b1b);

  &:focus-visible {
    border-radius: calc(infinity * 1px);
    outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
    outline-offset: 2px;
  }
}

.wui-radio.is-disabled {
  cursor: not-allowed;
  color: var(--wui-color-text-secondary, #6a6a6a);
  opacity: 0.4;
}

.wui-radio-circle {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 18px;
  height: 18px;
  border-radius: calc(infinity * 1px);

  background-color: var(--wui-color-surface-raised, #f2f2f7);

  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.is-checked .wui-radio-circle {
  background-color: var(--wui-color-accent, #08f);
}

.wui-radio-dot {
  transform: scale(0.85);

  width: 8px;
  height: 8px;
  border-radius: calc(infinity * 1px);

  opacity: 0;
  background-color: var(--wui-color-surface, #fff);
  box-shadow:
    inset 0 -1px 2px rgb(0 0 0 / 0.12),
    inset 0 1px 2px rgb(255 255 255 / 0.5),
    0 0 4px rgb(0 136 255 / 0.3);

  transition:
    opacity var(--wui-duration-trigger, 160ms) ease,
    transform var(--wui-duration-trigger, 160ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
}

.is-checked .wui-radio-dot {
  transform: scale(1);
  opacity: 1;
}

.wui-radio-label {
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .wui-radio-dot,
  .is-checked .wui-radio-dot {
    transform: none;
  }
}
